const UMPIRE_STATS_ID_KEY = "umpireStatsId";
const LEGACY_UMPIRE_ORG_ID_KEY = "umpireOrgId";
const LEGACY_UMPIRE_ID_KEY = "umpireId";

export type UmpireNavSource = {
    umpireStatsId?: number | null;
    name?: string | null;
    numberGuests?: number | null;
};

export const persistUmpireNavContext = (umpire: UmpireNavSource): void => {
    if (umpire.umpireStatsId != null) {
        localStorage.setItem(UMPIRE_STATS_ID_KEY, String(umpire.umpireStatsId));
    }
    localStorage.removeItem(LEGACY_UMPIRE_ID_KEY);
    localStorage.removeItem(LEGACY_UMPIRE_ORG_ID_KEY);
    if (umpire.name) {
        localStorage.setItem("umpireName", umpire.name);
    }
    if (umpire.numberGuests != null && umpire.numberGuests > 0) {
        localStorage.setItem("umpireNumberGuests", String(umpire.numberGuests));
    } else {
        localStorage.removeItem("umpireNumberGuests");
    }
};

/** Prefer umpireStatsId; fall back to leftover umpireOrgId (already Stats person id after prior ticket). */
export const readStoredUmpireStatsId = (): number | null => {
    const stored = localStorage.getItem(UMPIRE_STATS_ID_KEY);
    if (stored) {
        const parsed = parseInt(stored, 10);
        return Number.isFinite(parsed) ? parsed : null;
    }
    const legacyOrgId = localStorage.getItem(LEGACY_UMPIRE_ORG_ID_KEY);
    if (legacyOrgId) {
        const parsed = parseInt(legacyOrgId, 10);
        return Number.isFinite(parsed) ? parsed : null;
    }
    return null;
};

export const consumeStoredUmpireStatsId = (): number | null => {
    const id = readStoredUmpireStatsId();
    localStorage.removeItem(UMPIRE_STATS_ID_KEY);
    localStorage.removeItem(LEGACY_UMPIRE_ORG_ID_KEY);
    return id;
};
